"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const LineChartIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "58",
  height: "28",
  viewBox: "0 0 58 28",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M51.463 3.213a3.002 3.002 0 00-2.998 2.998 3.002 3.002 0 002.998 2.999 3.002 3.002 0 002.999-2.999 3.002 3.002 0 00-2.999-2.998m0 9.209a6.22 6.22 0 01-6.212-6.21A6.22 6.22 0 0151.463 0a6.218 6.218 0 016.21 6.21 6.218 6.218 0 01-6.21 6.21",
      fill: "#4BAF5E",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M36.378 18.531a3.002 3.002 0 00-2.998 2.998 3.002 3.002 0 002.998 2.999 3.002 3.002 0 002.999-2.999 3.002 3.002 0 00-2.999-2.998m0 9.209a6.218 6.218 0 01-6.21-6.21 6.218 6.218 0 016.21-6.211 6.22 6.22 0 016.213 6.21 6.22 6.22 0 01-6.213 6.21M21.295 4.83a3.002 3.002 0 00-2.998 2.999 3.002 3.002 0 002.998 2.998 3.002 3.002 0 002.998-2.998 3.002 3.002 0 00-2.998-2.998m0 9.208a6.218 6.218 0 01-6.21-6.21 6.218 6.218 0 016.21-6.21 6.22 6.22 0 016.212 6.21 6.22 6.22 0 01-6.212 6.21M6.21 11.797a3.002 3.002 0 00-2.997 2.999 3.002 3.002 0 002.998 2.998 3.002 3.002 0 002.998-2.998 3.002 3.002 0 00-2.998-2.999m0 9.209A6.218 6.218 0 010 14.796a6.218 6.218 0 016.21-6.21 6.22 6.22 0 016.213 6.21 6.22 6.22 0 01-6.213 6.21",
      fill: "#FFF",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M40.226 19.025a1.609 1.609 0 01-1.129-2.75l7.118-7.023a1.611 1.611 0 012.273.013c.623.634.614 1.65-.015 2.273l-7.119 7.023a1.6 1.6 0 01-1.128.464M32.222 19.372c-.388 0-.776-.138-1.084-.422l-7.186-6.576a1.608 1.608 0 012.171-2.371l7.183 6.578a1.605 1.605 0 01-1.084 2.791M11.349 14.03a1.607 1.607 0 01-.703-3.051l5.412-2.63a1.607 1.607 0 111.405 2.889l-5.414 2.63a1.578 1.578 0 01-.7.162M4.65 14.796a1.56 1.56 0 113.12-.002 1.56 1.56 0 01-3.12.002",
      fill: "#FFF",
      className: "svg-fill-secondary"
    })]
  })]
});

LineChartIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(LineChartIcon);

exports.default = _default;